namespace GeniuzPOS.Lookups {
    export namespace VpoSparamService {
        export const baseUrl = 'Lookups/VpoSparam';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VpoSparamRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VpoSparamRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VpoSparam/Retrieve",
            List = "Lookups/VpoSparam/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VpoSparamService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
